/**
 * @flow
 * @format
 */

import _LargeTable from './LargeTable';

export default _LargeTable;



// WEBPACK FOOTER //
// ./src/components/LargeTable/index.js